import { render, staticRenderFns } from "./collapseComponent.vue?vue&type=template&id=30d2fddc&scoped=true"
import script from "./collapseComponent.vue?vue&type=script&lang=js"
export * from "./collapseComponent.vue?vue&type=script&lang=js"
import style0 from "./collapseComponent.vue?vue&type=style&index=0&id=30d2fddc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d2fddc",
  null
  
)

export default component.exports